// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__NRlqJ","meals-appear":"AvailableMeals_meals-appear__jKXZD"};